import {Box, Button, Typography} from '@mui/material'
import {useConnection} from '../../components/hooks/ConnectionProvider'

const Home = () => {
    const {saveFetch} = useConnection()
    return (
        <Box className="PageContainer">
            <Button
                type="button"
                fullWidth
                variant="contained"
                onClick={() =>
                    saveFetch(
                        'https://jsonplaceholder.typicode.com/posts',
                        {},
                    ).then((res) => console.log(res))
                }
            >
                TEST
            </Button>
        </Box>
    )
}

export default Home
